module.exports = __webpack_public_path__ + "static/img/platform-bg-659.129acb4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/platform-bg-659.png
// module id = ylsH
// module chunks = 1